var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"x-icon-img",style:(_vm.style),attrs:{"src":_vm.src,"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }